module.exports = __webpack_public_path__ + "static/media/call-out.447f7aff.svg";